import { Modal, Tabs, TabsProps } from 'antd';
import React, { FC, useState } from 'react';
import { TDivisionResponse, TOrganizationResponse } from 'app/services/edpApiV1/moderator';
import DivisionsSearch from 'features/news/modalAddUsers/divisionsSearch/DivisionsSearch';
import OrganizationsSearch from 'features/news/modalAddUsers/organizationsSearch/OrganizationsSearch';
import { useLazyGetPollDivisionQuery, useLazyGetPollOrganizationQuery } from 'app/services/edpApiV1/poll';

type TModalAddDivisionsProps = {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  selectedDivisions?: TDivisionResponse[];
  addDivisions: (divisions: TDivisionResponse[]) => void;
  selectedOrganizations?: TOrganizationResponse[];
  addOrganizations: (divisions: TOrganizationResponse[]) => void;
};

const ModalAddDivisions: FC<TModalAddDivisionsProps> = ({
  onCancel,
  onOk,
  open,
  addDivisions,
  selectedDivisions,
  addOrganizations,
  selectedOrganizations,
}) => {
  const [activeTab, setActiveTab] = useState('divisions');
  const [getPollDivisionsQuery, { data, isFetching }] = useLazyGetPollDivisionQuery();
  const [getPollOrganizationsQuery, { data: organizationsData, isFetching: organizationsFetching }] =
    useLazyGetPollOrganizationQuery();
  const onModalSubmit = () => {
    onOk();
  };
  const onModalCancel = () => {
    onCancel();
  };

  const items: TabsProps['items'] = [
    {
      key: 'divisions',
      label: 'Подразделения',
      children: (
        <DivisionsSearch
          getDivisionsQuery={getPollDivisionsQuery}
          data={data}
          isFetching={isFetching}
          addDivisions={addDivisions}
          selectedDivisions={selectedDivisions}
          isActive={activeTab === 'divisions'}
        />
      ),
    },
    {
      key: 'organizations',
      label: 'Организации',
      children: (
        <OrganizationsSearch
          getOrganizationsQuery={getPollOrganizationsQuery}
          data={organizationsData}
          isFetching={organizationsFetching}
          addOrganizations={addOrganizations}
          selectedOrganizations={selectedOrganizations}
          isActive={activeTab === 'organizations'}
        />
      ),
    },
  ];

  return (
    <Modal title={<p>Выберите пользователей</p>} open={open} onOk={onModalSubmit} onCancel={onModalCancel} width={850}>
      <Tabs defaultActiveKey="divisions" items={items} activeKey={activeTab} onChange={setActiveTab} />
    </Modal>
  );
};

export default ModalAddDivisions;
